var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7384_71708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.49992 3.33398H13.8333L17.1666 6.66732V15.0007C17.1666 15.4427 16.991 15.8666 16.6784 16.1792C16.3659 16.4917 15.9419 16.6673 15.4999 16.6673H5.49992C5.05789 16.6673 4.63397 16.4917 4.32141 16.1792C4.00885 15.8666 3.83325 15.4427 3.83325 15.0007V5.00065C3.83325 4.55862 4.00885 4.1347 4.32141 3.82214C4.63397 3.50958 5.05789 3.33398 5.49992 3.33398Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83325 11.6667C8.83325 12.1087 9.00885 12.5326 9.32141 12.8452C9.63397 13.1577 10.0579 13.3333 10.4999 13.3333C10.9419 13.3333 11.3659 13.1577 11.6784 12.8452C11.991 12.5326 12.1666 12.1087 12.1666 11.6667C12.1666 11.2246 11.991 10.8007 11.6784 10.4882C11.3659 10.1756 10.9419 10 10.4999 10C10.0579 10 9.63397 10.1756 9.32141 10.4882C9.00885 10.8007 8.83325 11.2246 8.83325 11.6667Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 3.33398V6.66732H7.16675V3.33398",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7384_71708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.7b1312173450ca3d266293bee4fdcbf7.svg";
export { ForwardRef as ReactComponent };